'use client'
import { isIPad, isIPhone } from '@dynamic-labs/utils';
import { getWalletLinks } from '@dynamic-labs/wallet-book';

const handleMobileWalletFilter = (walletBook, walletKey, metadata) => {
    if (!metadata.mobile)
        return false;
    /**
     * WalletConnect provides a "universal" and "native" deep link. They recommend using
     * the universal deep link over the native one due to UX differences, and our current
     * implementation uses only universal. This means we need to filter for wallets that
     * have a universal deep link available.
     */
    const hasWalletConnectLink = Boolean(metadata.mobile.universal) || Boolean(metadata.mobile.native);
    const isWalletConnectWallet = metadata.walletConnect !== undefined;
    if (isIPad() || isIPhone()) {
        const hasIOSLink = Boolean(getWalletLinks(walletBook, walletKey).ios);
        return !isWalletConnectWallet
            ? hasIOSLink
            : hasIOSLink && hasWalletConnectLink;
    }
    else {
        const hasAndroidLink = Boolean(getWalletLinks(walletBook, walletKey).android);
        return !isWalletConnectWallet
            ? hasAndroidLink
            : hasAndroidLink && hasWalletConnectLink;
    }
};

export { handleMobileWalletFilter };
